import {
  AddGioDeviceRequest,
  GioDeviceInfo,
  GioRestEndpoints,
  IGioDeviceInfo,
  UpdateDeviceExpansionsByIdRequest,
} from '@scaleaq/sitecontrol-lib';

import { API_NAMES, CACHE_KEYS } from '@/constants';
import {
  useAuthApiDeleteById,
  useAuthApiGetSingleFetch,
  useAuthApiPost,
  useAuthApiUpdate,
  type ServiceQueryOptions,
} from '@/dataAccess/rest/apiHooks';

export const useGioDevices = ({ enabled }: ServiceQueryOptions = {}) => {
  return useAuthApiGetSingleFetch<IGioDeviceInfo[]>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices],
    route: GioRestEndpoints.getDevices,
    enabled,
  });
};

export const useAddGioDevice = (identifier?: string) => {
  return useAuthApiPost<AddGioDeviceRequest, GioDeviceInfo>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices],
    identifier: identifier || 'useAddGioDevice',
    returnJsonResult: true,
    route: GioRestEndpoints.addDevice,
  });
};
export const useRemoveGioDeviceById = (identifier?: string) => {
  return useAuthApiDeleteById<IGioDeviceInfo & { id: string }>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices],
    identifier: identifier || 'useRemoveGioDeviceById',
    route: GioRestEndpoints.deleteDeviceById,
  });
};
export const useUpdateGioDevice = (id: string, identifier?: string) => {
  return useAuthApiUpdate<UpdateDeviceExpansionsByIdRequest>({
    baseApiRoute: API_NAMES.gioApi,
    cacheKeys: [CACHE_KEYS.allGioDevices, id],
    id: id,
    identifier: identifier || 'useUpdateGioDevice',
    putOrPatch: 'PUT',
    route: `${GioRestEndpoints.updateDeviceExpansions}`,
  });
};
